module.exports = __webpack_public_path__ + "static/media/dicon-2.8c365695.svg";